import { initPopovers } from '../core/bootstrap-helpers.js';
import { spinnerHtml } from '../core/utilities.js';
import { validateOrderRows } from './validation.js';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/** Ignore stale inventory responses when the user changes line/inputs quickly */
var inventoryRequestSeq = 0;

function decodePartNumberForWarehouse(pn) {
    if (pn == null || pn === '') {
        return pn;
    }
    var s = String(pn);
    if (!/%[0-9A-Fa-f]{2}/.test(s)) {
        return s;
    }
    try {
        return decodeURIComponent(s);
    } catch (e) {
        return s;
    }
}

export var productAvailabilityAvailable = '';
export var productAvailabilityOutOfStock = '';
export var productAvailabilityUnavailable = '';
export var productAvailabilityBackorder = '';
export var productAvailabilityDropship = '';
export var pricingFallbackMessage = '';
export var disableOrderingOnFallback = false;
export var stockDisplayCap = 0;
/** Label for "order" from hidden `#order-text` (set via `setInventoryConfig`). */
export var customOrderText = '';

export function setInventoryConfig(config) {
    if (config.productAvailabilityAvailable !== undefined) {
        productAvailabilityAvailable = config.productAvailabilityAvailable;
    }
    if (config.productAvailabilityOutOfStock !== undefined) {
        productAvailabilityOutOfStock = config.productAvailabilityOutOfStock;
    }
    if (config.productAvailabilityUnavailable !== undefined) {
        productAvailabilityUnavailable = config.productAvailabilityUnavailable;
    }
    if (config.productAvailabilityBackorder !== undefined) {
        productAvailabilityBackorder = config.productAvailabilityBackorder;
    }
    if (config.productAvailabilityDropship !== undefined) {
        productAvailabilityDropship = config.productAvailabilityDropship;
    }
    if (config.pricingFallbackMessage !== undefined) {
        pricingFallbackMessage = config.pricingFallbackMessage;
    }
    if (config.disableOrderingOnFallback !== undefined) {
        disableOrderingOnFallback = config.disableOrderingOnFallback;
    }
    if (config.stockDisplayCap !== undefined) {
        stockDisplayCap = config.stockDisplayCap;
    }
    if (config.customOrderText !== undefined) {
        customOrderText =
            config.customOrderText != null
                ? String(config.customOrderText)
                : '';
    }
}

export function getItemInventory($element, productData) {
    var mySeq = ++inventoryRequestSeq;
    var viewAsAccount = $('#vaa').length ? '?au=' + $('#vaa').val() : '';
    var $inventoryMessage = $element.find('.multi-order-inventory');
    var $costMessage = $element.find('.multi-order-cost');
    var inventoryMessageIsCell = $inventoryMessage.is('td');
    var $quantity = $element.find('.multi-order-quantity');
    var quantity = $quantity.val();

    var aaia =
        typeof $element.attr('data-aaia') !== typeof undefined &&
        $element.attr('data-aaia') !== false
            ? $element.attr('data-aaia')
            : productData.aaia;

    productData.aaia = aaia;
    if (productData.partnumber != null && productData.partnumber !== '') {
        productData.partnumber = decodePartNumberForWarehouse(
            productData.partnumber
        );
    }

    var whlc = $element.attr('data-whlc');
    var whsn = $element.attr('data-whsn');
    if (
        (productData.linecode == null || productData.linecode === '') &&
        whlc != null &&
        whlc !== ''
    ) {
        productData.linecode = whlc;
    }
    if (
        (productData.stocknumber == null || productData.stocknumber === '') &&
        whsn != null &&
        whsn !== ''
    ) {
        productData.stocknumber = whsn;
    }

    var backordering = $('#backordering').length
        ? $('#backordering').val()
        : false;

    var noStock = $('#orderModal').find('.no-stock').length;

    var brandSettings = {
        Backorder: '0',
        Dropship: '0',
        IncludeAAMGroupInventory: '0',
        IncludeManufacturerInventory: '0',
        LeadTimeDays: '',
        DropshipFlatRateShippingCost: '',
    };

    $inventoryMessage.empty();
    $costMessage.empty();

    var ajaxOptions = {
        // No trailing slash: a redirect to the canonical URL drops POST body (no Payload in DevTools).
        url: 'whs/get_inventory_and_pricing' + viewAsAccount,
        type: 'post',
        dataType: 'json',
        data: {
            parts: [productData],
        },
        error: function () {
            if (mySeq !== inventoryRequestSeq) {
                return;
            }
            if (inventoryMessageIsCell) {
                $inventoryMessage.html(
                    '<span class="text-danger small">Pricing unavailable</span>'
                );
            } else {
                $inventoryMessage.html(
                    '<p class="text-danger small">Pricing unavailable</p>'
                );
            }
            $costMessage.html('');
            if (inventoryMessageIsCell) {
                validateOrderRows($element.closest('table'));
            }
        },
        success: function (json) {
            if (mySeq !== inventoryRequestSeq) {
                return;
            }
            if (!json || !json[0]) {
                if (inventoryMessageIsCell) {
                    $inventoryMessage.html(
                        '<span class="text-warning small">Stock unavailable</span>'
                    );
                } else {
                    $inventoryMessage.html(
                        '<p class="text-warning small">Stock unavailable</p>'
                    );
                }
                if (inventoryMessageIsCell) {
                    validateOrderRows($element.closest('table'));
                }
                return;
            }

            var data = json[0];
            var totalInventory = 0;
            var warehouseInventory = 0;
            var additionalInventory = 0;

            for (var key in data.warehouse_inventory_by_location) {
                warehouseInventory += parseInt(
                    data.warehouse_inventory_by_location[key]
                );
            }

            if (
                backordering &&
                brandSettings['Backorder'] == '1' &&
                (brandSettings['IncludeManufacturerInventory'] == '1' ||
                    brandSettings['IncludeAAMGroupInventory'] == '1')
            ) {
                

                if (data.hasOwnProperty('aam_inventory_locations')) {
                    for (var key in data.aam_inventory_locations) {
                        var location = data.aam_inventory_locations[key];

                        if (parseInt(location.inventory) === 0) {
                            continue;
                        }

                        additionalInventory += parseInt(location.inventory);
                    }
                } else if (parseInt(data.aam_inventory) > 0) {
                    additionalInventory += parseInt(data.aam_inventory);
                }
                
                if (data.hasOwnProperty('man_inventory_locations')) {
                    for (var key in data.man_inventory_locations) {
                        var location = data.man_inventory_locations[key];

                        if (parseInt(location.inventory) === 0) {
                            continue;
                        }

                        additionalInventory += parseInt(location.inventory);
                    }
                } else if (parseInt(data.man_inventory) > 0) {
                    additionalInventory += parseInt(data.man_inventory);
                }
            }

            totalInventory = warehouseInventory + additionalInventory;

            $quantity.attr('min', 0);

            if (data.hasOwnProperty('orderable') && data.orderable === false) {
                if (inventoryMessageIsCell) {
                    $inventoryMessage.html(
                        '<span class="text-danger" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-content="This product cannot be ordered."><i class="fa fa-exclamation-triangle"></i></span>'
                    );
                } else {
                    $inventoryMessage.html(
                        '<p class="text-danger">This product cannot be ordered.</p>'
                    );
                }

                $element.removeClass('valid').addClass('error');
            } else {
                if (
                    warehouseInventory == 0 &&
                    additionalInventory > 0 &&
                    backordering &&
                    brandSettings['Backorder'] == '1'
                ) {
                    var text = productAvailabilityDropship;

                    if (brandSettings['Dropship'] == '0') {
                        text = productAvailabilityBackorder;
                    } else if (brandSettings['LeadTimeDays'].length) {
                        text += ' (' + brandSettings['LeadTimeDays'];

                        if (
                            brandSettings['DropshipFlatRateShippingCost'].length
                        ) {
                            text +=
                                ', ' +
                                brandSettings['DropshipFlatRateShippingCost'];
                        }

                        text += ')';
                    }
                }

                if (inventoryMessageIsCell) {
                    if (noStock) {
                        $inventoryMessage.html(
                            '<span class="text-success" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-content="' +
                                productAvailabilityAvailable +
                                ' (Last updated ' +
                                dayjs(data.datetime).fromNow() +
                                ')"><i class="fa fa-check"></i></span>'
                        );
                    } else {
                        if (
                            warehouseInventory == 0 &&
                            additionalInventory > 0 &&
                            backordering &&
                            brandSettings['Backorder'] == '1'
                        ) {
                            $inventoryMessage.html(
                                '<span class="text-success" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-content="' +
                                    text +
                                    '"><i class="fa fa-check"></i></span>'
                            );
                        } else {
                            $inventoryMessage.html(
                                '<span class="badge bg-success" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-content="' +
                                    (stockDisplayCap > 0 && totalInventory > stockDisplayCap ? stockDisplayCap + '+' : totalInventory) +
                                    ' in stock (Last updated ' +
                                    dayjs(data.datetime).fromNow() +
                                    ')">' +
                                    (stockDisplayCap > 0 && totalInventory > stockDisplayCap ? stockDisplayCap + '+' : totalInventory) +
                                    '</span>'
                            );
                        }
                    }
                } else {
                    if (noStock) {
                        $inventoryMessage.html(
                            '<p class="text-success">' +
                                productAvailabilityAvailable +
                                ' <span class="text-muted">(Last updated ' +
                                dayjs(data.datetime).fromNow() +
                                ')</span></p>'
                        );
                    } else {
                        if (
                            warehouseInventory == 0 &&
                            additionalInventory > 0 &&
                            backordering &&
                            brandSettings['Backorder'] == '1'
                        ) {
                            $inventoryMessage.html(
                                '<p class="text-success">' +
                                    text +
                                    ' <span class="text-muted">(Last updated ' +
                                    dayjs(data.datetime).fromNow() +
                                    ')</span></p>'
                            );
                        } else {
                            $inventoryMessage.html(
                                '<p class="text-success">' +
                                    (stockDisplayCap > 0 && totalInventory > stockDisplayCap ? stockDisplayCap + '+' : totalInventory) +
                                    ' in stock <span class="text-muted">(Last updated ' +
                                    dayjs(data.datetime).fromNow() +
                                    ')</span></p>'
                            );
                        }
                    }
                }

                if (
                    totalInventory == 0 &&
                    (backordering == false || brandSettings['Backorder'] == '0')
                ) {
                    $quantity.val('');
                    $element.removeClass('valid').addClass('error');
                } else {
                    if (parseInt(quantity) > 0) {
                        $quantity.val(quantity);
                    } else {
                        $quantity.val('1');
                    }

                    $element.removeClass('error').addClass('valid');
                }
            }

            if ($costMessage.length && data.account_price) {
                var accountPrice = parseFloat(data.account_price);

                if (accountPrice > 0) {
                    $costMessage.text('$' + accountPrice.toFixed(2));
                }
            }

            if (inventoryMessageIsCell) {
                if (
                    data.disable_instant_order_on_no_inv &&
                    data.hasOwnProperty(
                        'warehouse_inventory_default_location'
                    ) &&
                    data.warehouse_inventory_default_location === 0
                ) {
                    $element.addClass('no-inst');
                }
                validateOrderRows($element.closest('table'));
            }

            initPopovers();
        },
    };

    $.ajax({
        url: 'catalog/ajaxGetBrand/' + aaia,
        type: 'post',
        dataType: 'json',
        beforeSend: function () {
            if (inventoryMessageIsCell) {
                $inventoryMessage.html(
                    '<span class="text-muted">' + spinnerHtml() + '</span>'
                );
            } else {
                $inventoryMessage.html(
                    '<span class="text-muted">' + spinnerHtml('Loading inventory...') + '</span>'
                );
            }
        },
        error: function () {
            if (mySeq !== inventoryRequestSeq) {
                return;
            }
            if (inventoryMessageIsCell) {
                $inventoryMessage.html(
                    '<span class="text-danger small">Brand lookup failed</span>'
                );
            } else {
                $inventoryMessage.html(
                    '<p class="text-danger small">Brand lookup failed</p>'
                );
            }
            if (inventoryMessageIsCell) {
                validateOrderRows($element.closest('table'));
            }
        },
        success: function (data) {
            if (mySeq !== inventoryRequestSeq) {
                return;
            }
            for (var key in brandSettings) {
                brandSettings[key] = data.hasOwnProperty(key) ? data[key] : '0';
            }

            $.ajax(ajaxOptions);
        },
    });
}

export function getMultiItemInventory($table, _OrderItems) {
    var backordering = $('#backordering').length
        ? $('#backordering').val()
        : false;
    var batches = [];
    var $auInput = $('#au');
    var viewAsAccount = $auInput.length ? '?au=' + $auInput.val() : '';

    $table
        .find('tr')
        .not('.default-row')
        .each(function (i, item) {
            batches.push({
                aaia: $(item).find('.multi-order-brand').val(),
                partnumber: $(item).find('.multi-order-part-number').val(),
                gtin: $(item).find('.multi-order-gtin').val(),
                linecode: $(item).attr('data-whlc'),
                stocknumber: $(item).attr('data-whsn'),
            });
        });

    $.ajax({
        url: 'whs/get_inventory_and_pricing' + viewAsAccount,
        type: 'post',
        dataType: 'json',
        data: { parts: batches },
        beforeSend: function () {
            $table
                .find('tr:not(.default-row) .multi-order-inventory')
                .html(
                    '<span class="text-muted">' + spinnerHtml() + '</span>'
                );
        },
        error: function () {
            $table.find('tr:not(.default-row) .multi-order-inventory').html('');
        },
        success: function (data) {
            var rowIndex = 0;

            for (var key in data) {
                var item = data[key];
                var $element = $table.find('tr').eq(rowIndex);
                var $inventoryMessage = $element.find('.multi-order-inventory');
                var noStock = $element.closest('table').hasClass('no-stock');
                var $quantity = $element.find('.multi-order-quantity');
                var quantity = $quantity.val();
                var totalInventory = 0;
                var warehouseInventory = 0;
                var additionalInventory = 0;
                var brandSettings = {
                    Backorder: '0',
                    Dropship: '0',
                    IncludeAAMGroupInventory: '0',
                    IncludeManufacturerInventory: '0',
                    LeadTimeDays: '',
                    DropshipFlatRateShippingCost: '',
                };

                if (key == 'error') {
                    $inventoryMessage.html(
                        '<span class="text-danger" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-content="An error occurred."><i class="fa fa-exclamation-triangle"></i></span>'
                    );
                    $element.removeClass('valid').addClass('error');
                } else {
                    if (key in _OrderItems) {
                        for (var setting in brandSettings) {
                            brandSettings[setting] =
                                _OrderItems[key].item.brand[setting];
                        }
                    }

                    for (var whKey in item.warehouse_inventory_by_location) {
                        warehouseInventory += parseInt(
                            item.warehouse_inventory_by_location[whKey]
                        );
                    }

                    if (
                        backordering &&
                        brandSettings['Backorder'] == '1' &&
                        (brandSettings['IncludeManufacturerInventory'] == '1' ||
                            brandSettings['IncludeAAMGroupInventory'] == '1')
                    ) {

                        if (item.hasOwnProperty('aam_inventory_locations')) {
                            for (var aamKey in item.aam_inventory_locations) {
                                var location =
                                    item.aam_inventory_locations[aamKey];

                                if (parseInt(location.inventory) === 0) {
                                    continue;
                                }

                                additionalInventory += parseInt(
                                    location.inventory
                                );
                            }
                        } else if (parseInt(item.aam_inventory) > 0) {
                            additionalInventory += parseInt(item.aam_inventory);
                            item.warehouse_inventory_by_location[
                                'AAM Group Inventory'
                            ] = item.aam_inventory;
                        }
                        
                        if (item.hasOwnProperty('man_inventory_locations')) {
                            for (var manKey in item.man_inventory_locations) {
                                var location =
                                    item.man_inventory_locations[manKey];

                                if (parseInt(location.inventory) === 0) {
                                    continue;
                                }

                                additionalInventory += parseInt(
                                    location.inventory
                                );
                            }
                        } else if (parseInt(item.man_inventory) > 0) {
                            additionalInventory += parseInt(item.man_inventory);
                            item.warehouse_inventory_by_location[
                                'Manufacturer Inventory'
                            ] = item.man_inventory;
                        }
                        
                    }

                    totalInventory = warehouseInventory + additionalInventory;

                    $quantity.attr('min', 0);

                    if (
                        item.hasOwnProperty('orderable') &&
                        item.orderable === false
                    ) {
                        $inventoryMessage.html(
                            '<span class="text-danger" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-content="This product cannot be ordered."><i class="fa fa-exclamation-triangle"></i></span>'
                        );
                        $element.removeClass('valid').addClass('error');
                    } else {
                        if (
                            warehouseInventory == 0 &&
                            additionalInventory > 0 &&
                            backordering &&
                            brandSettings['Backorder'] == '1'
                        ) {
                            var text = productAvailabilityDropship;

                            if (brandSettings['Dropship'] == '0') {
                                text = productAvailabilityBackorder;
                            } else if (brandSettings['LeadTimeDays'].length) {
                                text += ' (' + brandSettings['LeadTimeDays'];

                                if (
                                    brandSettings[
                                        'DropshipFlatRateShippingCost'
                                    ].length
                                ) {
                                    text +=
                                        ', ' +
                                        brandSettings[
                                            'DropshipFlatRateShippingCost'
                                        ];
                                }

                                text += ')';
                            }
                        }

                        if (noStock) {
                            $inventoryMessage.html(
                                '<span class="text-success" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-content="' +
                                    productAvailabilityAvailable +
                                    ' (Last updated ' +
                                    dayjs(item.datetime).fromNow() +
                                    ')"><i class="fa fa-check"></i></span>'
                            );
                        } else {
                            if (
                                warehouseInventory == 0 &&
                                additionalInventory > 0 &&
                                backordering &&
                                brandSettings['Backorder'] == '1'
                            ) {
                                $inventoryMessage.html(
                                    '<span class="text-success" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-content="' +
                                        text +
                                        '"><i class="fa fa-check"></i></span>'
                                );
                            } else {
                                $inventoryMessage.html(
                                    '<span class="badge bg-success" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" data-bs-trigger="hover" data-bs-content="' +
                                        (stockDisplayCap > 0 && totalInventory > stockDisplayCap ? stockDisplayCap + '+' : totalInventory) +
                                        ' in stock (Last updated ' +
                                        dayjs(item.datetime).fromNow() +
                                        ')">' +
                                        (stockDisplayCap > 0 && totalInventory > stockDisplayCap ? stockDisplayCap + '+' : totalInventory) +
                                        '</span>'
                                );
                            }
                        }

                        if (
                            totalInventory == 0 &&
                            (backordering == false ||
                                brandSettings['Backorder'] == '0')
                        ) {
                            $quantity.val('');
                            $element.removeClass('valid').addClass('error');
                        } else {
                            if (parseInt(quantity) > 0) {
                                $quantity.val(quantity);
                            } else {
                                $quantity.val('1');
                            }

                            $element.removeClass('error').addClass('valid');
                        }

                        if (
                            item.disable_instant_order_on_no_inv &&
                            item.hasOwnProperty(
                                'warehouse_inventory_default_location'
                            ) &&
                            item.warehouse_inventory_default_location === 0
                        ) {
                            $element.addClass('no-inst');
                        }
                    }
                }

                rowIndex++;
            }

            validateOrderRows($table);

            initPopovers();
        },
    });
}
